import * as types from "./actionsTypes";
import { agent } from "../utils/agent";
import { setToaster, showToaster } from "../utils/helpers";
import * as API from "../utils/apiPath";
import toggleNetworkRequestStatus from "./toggleNetworkRequestStatus";

/* ===============================
   SUCCESS ACTIONS
================================= */

export function colendingDataSuccess(colendingData) {
  return { type: types.LOAD_COLENDING_DATA_SUCCESS, colendingData };
}

export function colendingInfoSuccess(colendingInfo) {
  return { type: types.LOAD_COLENDING_INFO_SUCCESS, colendingInfo };
}


/* ===============================
   CREATE / UPDATE
================================= */

const createColendingMaster = (params) => {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    try {
      const response = await agent.post(API.CU_COLENDING_MASTER, params);
      dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      dispatch(toggleNetworkRequestStatus(false));
      throw error;
    }
  };
};


/* ===============================
   LISTING
================================= */

const colendingData = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) dispatch(toggleNetworkRequestStatus(true));
    try {
      let response;
      if (returnVal) {
        response = await agent.post(API.GET_COLENDING_MASTER, params);
      } else {
        response = await agent.post(API.GET_COLENDING_MASTER, params);
      }
      if (preloader) dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      console.error("API Request Error:", error);
      if (preloader) dispatch(toggleNetworkRequestStatus(false));
      throw error;
    }
  };
};


/* ===============================
   SINGLE RECORD INFO (EDIT)
================================= */

const colendingInfo = (params, preloader = true, returnVal = false) => {
  return async function (dispatch) {
    if (preloader) dispatch(toggleNetworkRequestStatus(true));
    try {
      let response;
      if (returnVal) {
        response = await agent.post(API.GET_COLENDING_MASTER, params);
      } else {
        response = await agent.post(API.GET_COLENDING_MASTER, params);
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            dispatch(colendingInfoSuccess(response.data.data));
          }
        }
      }

      if (preloader) dispatch(toggleNetworkRequestStatus(false));
      return response;
    } catch (error) {
      console.error("API Request Error:", error);
      if (preloader) dispatch(toggleNetworkRequestStatus(false));
      throw error;
    }
  };
};


/* ===============================
   EXPORT DEFAULT
================================= */

export default {
  createColendingMaster,
  colendingData,
  colendingDataSuccess,
  colendingInfo,
  colendingInfoSuccess
};